import { type CommunityDetail, useCommunityQuery } from '@pba/react-network';
import type { ReactNode } from 'react';
import { ScrollToTop } from 'ui';
import { CommunityInvitationTokenQueryInvalidation } from './community-invitation-token-query-invalidation';
import { CommunityLayoutSkeleton } from './community-layout-skeleton';

type P = {
  children?: (community: CommunityDetail) => ReactNode;
  communityId: string;
  header?: (community: CommunityDetail) => ReactNode;
  invitationToken?: string;
};

const CommunityLayout = ({ children, communityId, header, invitationToken }: P) => {
  const { data: community, isError } = useCommunityQuery({
    filter: invitationToken ? { invitationToken } : {},
    id: communityId,
  });

  return (
    <>
      {invitationToken ? (
        <CommunityInvitationTokenQueryInvalidation
          communityId={communityId}
          invitationToken={invitationToken}
          queryResult={{ data: community, isError }}
        />
      ) : null}
      {community ? (
        <>
          <ScrollToTop />
          {/* TODO: Will be used in Task #87927 for Community header */}
          {header?.(community)}
          {children?.(community)}
        </>
      ) : (
        <CommunityLayoutSkeleton />
      )}
    </>
  );
};

export default CommunityLayout;
